export interface PersonalTodosSectionHeadProps {
  title: string;
  count: number;
  variant?: 'accent' | 'muted';
  'data-testid'?: string;
}

export function PersonalTodosSectionHead({
  title,
  count,
  variant = 'accent',
  'data-testid': testId
}: PersonalTodosSectionHeadProps) {
  return (
    <div
      className="pt-section-head"
      data-testid={testId}
      data-variant={variant}
    >
      <div className="pt-section-dot-col">
        <span className={`pt-section-dot pt-section-dot-${variant}`} />
        <span className="pt-section-count">{count}</span>
      </div>
      <h2 className="pt-section-title">{title}</h2>
    </div>
  );
}
